"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _moment = _interopRequireDefault(require("moment"));

var _reactDayPicker = _interopRequireWildcard(require("react-day-picker"));

var _date = _interopRequireDefault(require("@spothero/utils/date"));

var _DatePickerCalendarNavigation = _interopRequireDefault(require("./DatePickerCalendarNavigation"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = (0, _filter.default)(symbols).call(symbols, function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context3; (0, _forEach.default)(_context3 = ownKeys(Object(source), true)).call(_context3, function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { var _context4; (0, _forEach.default)(_context4 = ownKeys(Object(source))).call(_context4, function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

var DATE = new Date();
var DATE_FORMAT = 'MM/DD/YYYY';

var DatePickerCalendarWithRange = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(DatePickerCalendarWithRange, _Component);

  var _super = _createSuper(DatePickerCalendarWithRange);

  function DatePickerCalendarWithRange(props) {
    var _this;

    (0, _classCallCheck2.default)(this, DatePickerCalendarWithRange);
    _this = _super.call(this, props);
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_onDaySelected", function (day, _ref, evt) {
      var selected = _ref.selected,
          disabled = _ref.disabled;

      if (disabled) {
        return;
      }

      var onChange = _this.props.onChange;

      var _this$_updateDateRang = _this._updateDateRange(day),
          selectedStartDate = _this$_updateDateRang.to,
          selectedEndDate = _this$_updateDateRang.from;

      _this.setState({
        selectedStartDate: selectedStartDate,
        selectedEndDate: selectedEndDate
      });

      if (onChange) {
        onChange({
          selectedStartDate: selectedStartDate ? (0, _moment.default)(selectedStartDate).format(DATE_FORMAT) : null,
          selectedEndDate: selectedEndDate ? (0, _moment.default)(selectedEndDate).format(DATE_FORMAT) : null
        });
      }
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_updateDateRange", function (newDate) {
      var adjustStartOrEnd = _this.props.adjustStartOrEnd;
      var _this$state = _this.state,
          prevSelectedStartDate = _this$state.selectedStartDate,
          prevSelectedEndDate = _this$state.selectedEndDate;
      var newStartDate;
      var newEndDate;

      if (!prevSelectedStartDate || !prevSelectedEndDate) {
        // if both start and end dates aren't populated, use the default logic
        var _DayPickerDateUtils$a = _reactDayPicker.DateUtils.addDayToRange(newDate, {
          from: prevSelectedStartDate,
          to: prevSelectedEndDate
        }),
            from = _DayPickerDateUtils$a.from,
            to = _DayPickerDateUtils$a.to;

        newStartDate = from;
        newEndDate = to;
      } else if (adjustStartOrEnd === 'start') {
        // if start input is focused, update start date and clear end date
        newStartDate = newDate;
        newEndDate = null;
      } else if (adjustStartOrEnd === 'end' && !_reactDayPicker.DateUtils.isDayBefore(newDate, prevSelectedStartDate)) {
        // if end input is focused and newDate >= prevSelectedStartDate, update end date
        newStartDate = prevSelectedStartDate;
        newEndDate = newDate;
      } else if (adjustStartOrEnd === 'end' && _reactDayPicker.DateUtils.isDayBefore(newDate, prevSelectedStartDate)) {
        // if end input is focused and newDate < prevSelectedStartDate, update start date and clear end date
        newStartDate = newDate;
        newEndDate = null;
      }

      return {
        to: newStartDate,
        from: newEndDate
      };
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_renderDayMarkup", function (day) {
      var _context, _context2;

      var m = (0, _moment.default)(day);
      var date = (0, _concat.default)(_context = (0, _concat.default)(_context2 = "".concat(m.format('MM'), "/")).call(_context2, m.format('DD'), "/")).call(_context, m.format('YYYY'));
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "DatePicker-Day--wrapper"
      }, /*#__PURE__*/_react.default.createElement("span", {
        "data-date": date
      }, day.getDate()));
    });
    var _selectedStartDate = props.selectedStartDate,
        _selectedEndDate = props.selectedEndDate;
    _this.state = {
      selectedStartDate: _selectedStartDate ? _date.default.getAsDate(_selectedStartDate) : null,
      selectedEndDate: _selectedEndDate ? _date.default.getAsDate(_selectedEndDate) : null
    };
    return _this;
  }

  (0, _createClass2.default)(DatePickerCalendarWithRange, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          numberOfMonths = _this$props.numberOfMonths,
          weekdayTitles = _this$props.weekdayTitles,
          disableBefore = _this$props.disableBefore,
          disableAfter = _this$props.disableAfter,
          overrideInitialMonthWithSelected = _this$props.overrideInitialMonthWithSelected;
      var _this$state2 = this.state,
          selectedStartDate = _this$state2.selectedStartDate,
          selectedEndDate = _this$state2.selectedEndDate;
      var classes = (0, _classnames.default)('DatePicker-calendar', 'DatePicker-calendar-with-range', className);
      var firstMonth = DATE;
      var fromMonth = DATE;
      var toMonth = null;

      if (disableBefore) {
        var beforeDate = _date.default.getAsDate(disableBefore);

        if (fromMonth) {
          if (_date.default.isAfter(beforeDate, fromMonth)) {
            fromMonth = beforeDate;
          }
        } else {
          fromMonth = beforeDate;
        }

        firstMonth = fromMonth;
      }

      if (disableAfter) {
        toMonth = _date.default.getAsDate(disableAfter);
      }

      if (selectedStartDate && overrideInitialMonthWithSelected) {
        firstMonth = selectedStartDate;
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: classes
      }, /*#__PURE__*/_react.default.createElement(_reactDayPicker.default, {
        selectedDays: [selectedStartDate, {
          from: selectedStartDate,
          to: selectedEndDate
        }],
        modifiers: {
          start: selectedStartDate,
          end: selectedEndDate,
          'start-without-end': function startWithoutEnd(day) {
            return _reactDayPicker.DateUtils.isSameDay(day, selectedStartDate) && !selectedEndDate;
          }
        },
        disabledDays: _objectSpread({
          before: fromMonth
        }, toMonth && {
          after: toMonth
        }),
        fromMonth: fromMonth,
        toMonth: toMonth,
        initialMonth: firstMonth,
        onDayClick: this._onDaySelected,
        numberOfMonths: numberOfMonths,
        renderDay: this._renderDayMarkup,
        weekdaysShort: weekdayTitles,
        navbarElement: /*#__PURE__*/_react.default.createElement(_DatePickerCalendarNavigation.default, null)
      }));
    }
  }]);
  return DatePickerCalendarWithRange;
}(_react.Component);

exports.default = DatePickerCalendarWithRange;
(0, _defineProperty3.default)(DatePickerCalendarWithRange, "defaultProps", {
  numberOfMonths: 1,
  weekdayTitles: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  overrideInitialMonthWithSelected: true
});